import Vue from "vue";
import VueRouter from "vue-router";
import RouterPrefetch from 'vue-router-prefetch'
import App from "./App";
// TIP: change to import router from "./router/starterRouter"; to start with a clean layout
import router from "./router/index";
import axios from 'axios';
import VueApexCharts from 'vue-apexcharts'

import CallCenterDashboard from "./plugins/CallCenterDashboard";
import i18n from "./i18n"
import './registerServiceWorker'
Vue.use(CallCenterDashboard);
Vue.use(VueRouter);
Vue.use(RouterPrefetch);
Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);
/* eslint-disable no-new */
new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");
